// Core SPA Libray
import * as Core from './Library/Core.js';
import * as ServerSideRendering from './Library/ServerSideRendering.js';
import initServer from './InitServer.js';
import initBrowser from './InitBrowser.js';

// Namespace exports
export * as Core from './Library/Core.js';
export * as ContentDelivery from './Library/ContentDelivery.js';
export * as Layout from './Library/Layout.js';
export * as Routing from './Library/Routing.js';
export * as Taxonomy from './Library/Taxonomy.js';
export * as Services from './Library/Services.js';
export * as Components from './Library/Components.js';
export * as ComponentTypes from './Library/ComponentTypes.js';
export * as ServerSideRendering from './Library/ServerSideRendering.js';
export * as Tracking from './Library/Tracking.js';
export * as Loaders from './Library/Loaders.js';
export * as IndexedDB from './Library/IndexedDB.js';
export * as State from './Library/State.js';

/**
 * Generic initialization function, usable for both Browser & Server side rendering
 * 
 * @see     InitServer
 * @see     InitBrowser
 * @param   {Core.IConfig}         config              The main configuration object
 * @param   {Core.IServiceContainer}  serviceContainer    The service container to use, if a specific one is desired
 * @param   {string}            containerElementId  The element that should be populated by React-DOM on the Browser
 * @param   {boolean}           ssr                 Marker to hint Server Side rendering
 * @returns {ServerSideRendering.Response|void}  The result of the initialization method invoked
 */
export function init<B extends boolean> (config: Core.IConfig, serviceContainer?: Core.IServiceContainer, containerElementId?: string, ssr?: B) : B extends true ? ServerSideRendering.Response : void
{
    serviceContainer = serviceContainer || new Core.DefaultServiceContainer();
    if (ssr) {
        return initServer(config, serviceContainer) as B extends true ? ServerSideRendering.Response : void;
    } else {
        return initBrowser(config, containerElementId, serviceContainer) as B extends true ? ServerSideRendering.Response : void;
    }
}

/**
 * Export all hooks in the global scope
 */
export * from './Hooks/Context.js';

export { default as AppGlobal } from './AppGlobal.js';

export default init;